<template>
  <div>
    <v-autocomplete
      outlined
      hide-details
      v-model="modelValue.selected"
      :items="items"
      :label="label"
      :disabled="disabled"
      :rules="rules"
      :hint="hint"
      :placeholder="placeholder"
      :item-value="itemValue"
      :item-text="itemText"
      :return-object="returnObject"
      :multiple="multiple"
      deletable-chips
      class="font-size-14"
    >
      <template v-slot:selection="data">
        <v-chip outlined close-icon="mdi-close" :input-value="data.selected" close @click:close="remove(data.item)">
          {{ data.item.name }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-text-field
      dense
      class="mt-4"
      outlined
      v-if="modelValue.selected.includes('outras')"
      label="Descreve as outras complicações"
      v-model="modelValue.others"
    ></v-text-field>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'

export default {
  name: 'AutocompleteComponent',
  props: {
    value: {
      type: [Array, String, Number, Object],
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
    },
    itemValue: {
      type: String,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    const initialValue = { selected: [], others: null }
    const modelValue = isEmpty(this.value) ? initialValue : cloneDeep(this.value)

    return {
      modelValue,
    }
  },
  methods: {
    remove(item) {
      const key = item.key
      const index = this.modelValue.selected.indexOf(key)
      this.modelValue.selected.splice(index, 1)
      if (key === 'outras') this.modelValue.others = null
    },
  },
  watch: {
    modelValue: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.v-select :deep(label) {
  font-size: 14px;
}
</style>
